// React Query key factories. Metro tickets are namespaced under 'tickets',
// on-demand rides under 'rides' — symmetric shapes so the two categories never
// collide in the cache.
export const queryKeys = {
  cities: () => ['tickets', 'cities'] as const,
  operators: (cityCode: string) => ['tickets', 'operators', cityCode] as const,
  stations: (cityCode: string, vehicleCategory: string, operatorBppId = '') =>
    ['tickets', 'stations', cityCode, vehicleCategory, operatorBppId] as const,
  draft: (transactionId: string) => ['tickets', 'draft', transactionId] as const,
  list: () => ['tickets', 'list'] as const,
  detail: (id: string) => ['tickets', 'detail', id] as const,
  issues: (orderId: string) => ['tickets', orderId, 'issues'] as const,
  issue: (issueId: string) => ['tickets', 'issue', issueId] as const,
  allIssues: () => ['tickets', 'issues', 'all'] as const,
};

export const rideKeys = {
  draft: (transactionId: string) => ['rides', 'draft', transactionId] as const,
  list: () => ['rides', 'list'] as const,
  detail: (id: string) => ['rides', 'detail', id] as const,
  track: (id: string) => ['rides', 'track', id] as const,
  issues: (orderId: string) => ['rides', orderId, 'issues'] as const,
  issue: (issueId: string) => ['rides', 'issue', issueId] as const,
  allIssues: () => ['rides', 'issues', 'all'] as const,
};

// The authenticated user's own account/identity (GET /api/v1/users/me).
export const accountKeys = {
  profile: () => ['account', 'profile'] as const,
};

// Which ONDC transit product lines are live (GET /api/v1/transit/capabilities).
export const capabilityKeys = {
  all: () => ['capabilities'] as const,
};

// Operator policy is curated config that changes on the order of months, so it is keyed
// per city and cached hard.
export const operatorPolicyKeys = {
  city: (cityCode: string) => ['operator-policy', cityCode] as const,
};

export const passKeys = {
  draft: (transactionId: string) => ['passes', 'draft', transactionId] as const,
  list: () => ['passes', 'list'] as const,
  detail: (id: string) => ['passes', 'detail', id] as const,
  issues: (orderId: string) => ['passes', orderId, 'issues'] as const,
  issue: (issueId: string) => ['passes', 'issue', issueId] as const,
  allIssues: () => ['passes', 'issues', 'all'] as const,
};
